export const VEHICLE_NAME_LOOKUP_DEBOUNCE_TIMER = 600;

export default {};
